if (!customElements.get('video-testimonial')) {
  customElements.define(
    'video-testimonial',
    class VideoTestimonial extends HTMLElement {
      connectedCallback() {
        this.playBtn = this.querySelector('.testimonials__play-btn');
        if (!this.playBtn) return;
        this.onClick = this.onClick.bind(this);
        this.playBtn.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.playBtn) {
          this.playBtn.removeEventListener('click', this.onClick);
        }
      }

      onClick() {
        const videoSrc = this.dataset.videoSrc;
        const youtubeId = this.dataset.youtubeId || this.parseYouTubeId(this.dataset.externalUrl);
        const vimeoId = this.dataset.vimeoId || this.parseVimeoId(this.dataset.externalUrl);
        const externalUrl = this.dataset.externalUrl;

        if (videoSrc) {
          this.swapInPlayer(this.buildVideoElement(videoSrc));
          return;
        }
        if (youtubeId) {
          this.swapInPlayer(this.buildIframe(`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`));
          return;
        }
        if (vimeoId) {
          this.swapInPlayer(this.buildIframe(`https://player.vimeo.com/video/${vimeoId}?autoplay=1`));
          return;
        }
        if (externalUrl) {
          window.open(externalUrl, '_blank', 'noopener');
          return;
        }
        console.warn('[video-testimonial] No video source found on block.', this);
      }

      buildVideoElement(src) {
        const v = document.createElement('video');
        v.src = src;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        return v;
      }

      buildIframe(src) {
        const i = document.createElement('iframe');
        i.src = src;
        i.setAttribute('frameborder', '0');
        i.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        i.setAttribute('allowfullscreen', '');
        i.setAttribute('title', this.playBtn.getAttribute('aria-label') || 'Video testimonial');
        return i;
      }

      swapInPlayer(playerEl) {
        const wrapper = document.createElement('div');
        wrapper.className = 'testimonials__player';
        wrapper.appendChild(playerEl);
        this.playBtn.replaceWith(wrapper);
        this.playBtn = null;
        this.classList.add('is-playing');
      }

      parseYouTubeId(url) {
        if (!url) return '';
        const m =
          url.match(/[?&]v=([^&#]+)/) ||
          url.match(/youtu\.be\/([^?&#/]+)/) ||
          url.match(/youtube\.com\/embed\/([^?&#/]+)/);
        return m ? m[1] : '';
      }

      parseVimeoId(url) {
        if (!url) return '';
        const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        return m ? m[1] : '';
      }
    }
  );
}
